export default __webpack_public_path__ + "static/media/CN_Card_Blue.fa4dec6c.png";